
<!DOCTYPE html>
<body>
  <table style="border-collapse: collapse;">
    <thead>
      <router-outlet *ngIf="isConnect"></router-outlet>
      <!-- <router-outlet></router-outlet> -->
    </thead>
  </table>
</body>
